import { apiSlice } from "../../api/apiSlice";
import { GET_COACHING_CATEGORIES } from "../../constants";

export const CoachingCategoryDropdownSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getCoachingCategories: builder.query({
            query: () => {
                return {
                    url: GET_COACHING_CATEGORIES,
                };
            },
        }),
    }),
});

export const { useGetCoachingCategoriesQuery } = CoachingCategoryDropdownSlice;